<template>
  <div>
    <h2>{{ results && results.length || 0 }} {{ $t('airporthotel.results.available') }}</h2>
    <ul class="head-list list-unstyled">
      <li><i class="icon-idea"></i>{{ $t('airporthotel.filters.night_of_stay') }}: {{ formatDate(dateA, 'dddd, Do MMM YYYY') }}</li>
      <li><i class="icon-parking"></i>{{ $t('airporthotel.filters.parking_until') }}: {{ formatDate(dateB, 'dddd, Do MMM YYYY') }}</li>
    </ul>
  </div>
</template>

<script>
import { get } from "vuex-pathify";
import mixins from "@/mixins";

export default {
  name: "hotel-overview",
  mixins: [mixins.format],
  computed: {
    results: get("results/products@airporthotel"),
    ...get("quote/*")
  }
};
</script>